let defaultAttributes = [
	{
		key: "data-pcoplus-widget",
		name: "Widget Type",
		value: "calendar",
		type: "noEdit",
		group: null,
		hidden: true,
	},
	{
		key: "data-church-center-url",
		name: "Church Center URL",
		value: "",
		type: "noEdit",
		group: null,
		hidden: true,
	},
	{
		key: "data-display-art-in-calendar",
		name: "Display Art in Month View",
		value: true,
		type: "boolean",
		group: "Functionality",
	},
	{
		key: "data-display-art-in-day-view",
		name: "Display Art in Day View",
		value: true,
		type: "boolean",
		group: "Functionality",
	},
	{
		key: "data-filtertags",
		name: "Filter By Tag Name",
		help: "Comma separated",
		value: "",
		type: "text",
		group: "Functionality",
	},

	{
		key: "data-filter-tags-mode",
		name: "Tag Filter Mode",
		value: "Any",
		group: "Functionality",
		type: "select",
		condition: { "data-filter-tags": { method: "contains", value: "," } },
		options: [
			{ name: "Match All", value: "All" },
			{ name: "Match Any", value: "Any" },
		],
	},

	{
		key: "data-caption-register",
		name: "Register",
		value: "Register",
		type: "text",
		group: "Language",
	},
	{
		key: "data-caption-more-information",
		name: "More Information",
		value: "Learn More",
		type: "text",
		group: "Language",
	},
	{
		key: "data-caption-close",
		name: "Close Button",
		value: "Close",
		type: "text",
		group: "Language",
	},
	{
		key: "data-pcoplus-key",
		name: "PCO Chef API Key",
		value: "",
		type: "noEdit",
		group: null,
		hidden: true,
		required: true,
	},

	{
		key: "data-hide-tags",
		name: "Hide Tags",
		value: false,
		type: "boolean",
		group: "Functionality",
	},

	{
		key: "data-corner-radius",
		name: "Rounded Edge Radius",
		help: "(in points)",
		value: 4,
		type: "number",
		group: "Style",
		range: [0, 32],
	},
	{
		key: "data-calendar",
		name: "Show Calendar",
		value: false,
		type: "boolean",
		group: "Functionality",
		disabled: true,
	},

	{
		key: "data-month-offset",
		name: "Month Offset",
		value: 0,
		type: "number",
		group: "Functionality",
		range: [-12, 12],
	},

	// {
	// 	key: "data-dark-mode",
	// 	name: "Dark Mode",
	// 	value: false,
	// 	type: "boolean",
	// 	group: "Style",
	// },

	{
		key: "data-brand-color",
		name: "Brand Color",
		value: "#FF7461",
		group: "Style",
		type: "color",
	},
	{
		key: "data-button-color",
		name: "Button Color",
		value: "#4EA0CF",
		group: "Style",
		type: "color",
	},

	{
		key: "data-modal-color",
		name: "Modal Color",
		value: "#FFFFFF",
		group: "Style",
		type: "color",
	},

	{
		key: "data-text-color",
		name: "Text Color",
		value: "#333333",
		group: "Style",
		determineDarkMode: true,
		type: "color",
	},
];

export default defaultAttributes;
